import React from 'react'
import { Alert, Box, Card, FormControl, Heading, Link, ReadOnlyCopyInput, Select, Stack, Switch, Text } from '@/components/lib'
import api from '../../../api'
import utils from '../../../utils/utils'
import useStore from '../../../store'

export default function AvailabilityTab ({ trial }) {
  const { user, updateTrial } = useStore()

  const consentUrl = `${window.location.origin}/consent/${trial?.code}`

  function enable (eConsentEnabled) {
    api.trials.update(trial._id, { eConsentEnabled }, newTrial => {
      updateTrial(newTrial._id, newTrial)
    }, err => {
      utils.toast('error', err.message)
    })
  }

  function close (eConsentClosed) {
    api.trials.update(trial._id, { eConsentClosed }, newTrial => {
      updateTrial(newTrial._id, newTrial)
    }, err => {
      utils.toast('error', err.message)
    })
  }

  return (
    <Stack gap={5}>
      <Box>
        <Heading as='h2' size='md'>eConsent</Heading>
        <Text>Choose whether eConsent is enabled for this trial.</Text>
      </Box>

      {trial?.eConsentEnabled &&
        <Alert status='success' title='Managed eConsent is enabled for this trial'>
          <Stack>
            <Text>Participants must eConsent before they can take part in the trial by agreeing to one of your configured consent forms.</Text>
            <Text fontWeight='bold'>Participants can view and sign the default consent form at the URL below.</Text>
            <ReadOnlyCopyInput value={consentUrl} placeholder='https://join.trialflare.com/consent/…' />
            <Text fontSize='sm'>If your trial has multiple consent forms, you can find the other consent forms on the "Informed consent forms" tab.</Text>
          </Stack>
        </Alert>}

      {!trial?.eConsentEnabled &&
        <Alert status='info' title='eConsent is not enabled'>
          <Text>Participants can currently join the trial without first completing Trialflare's eConsent process.</Text>
        </Alert>}

      {!trial?.conditions &&
        <Alert status='warning' title='You need a privacy statement before you can enable eConsent'>
          <Text>The eConsent process collects personal data from participants. This data is processed and stored securely by Trialflare. However, as data controller with access to participant data, you must configure a Privacy statement (<Link to={`/trials/${trial?._id}/info`} color='teal'>in the "About" section</Link>) to inform participants about how their data will be used and safeguarded. Participants will be asked to agree to this statement before they can complete their consent.</Text>
        </Alert>}

      {utils.canWriteTrial(user, trial) &&
        <Card gap={1}>
          <Heading as='h3' size='sm'>Manage eConsent activation</Heading>
          <Stack direction={{ base: 'column', md: 'row' }} spacing={2} alignItems='center'>
            <FormControl>
              <Switch id='enable' isChecked={trial?.eConsentEnabled} onChange={e => enable(e.checked)} disabled={!trial?.conditions}>Enable eConsent</Switch>
            </FormControl>
            {trial?.eConsentEnabled &&
              <FormControl>
                <Select value={trial?.eConsentClosed ? 'true' : 'false'} onChange={e => close(e.target.value === 'true')}>
                  <option value='false'>Allow new eConsents</option>
                  <option value='true'>Prevent further eConsents (but still require participants to have eConsented)</option>
                </Select>
              </FormControl>}
          </Stack>
        </Card>}
    </Stack>
  )
}
